import { observer } from "mobx-react-lite";
import { useStore } from "../../../../helpers";
import type { SourceFile } from "../sidebar/sources-types";
import { isFolder } from "../sidebar/sources-types";
import FacetJsonWorkspacePanel from "./FacetJsonWorkspacePanel";
import DataBankAnalyticsPanel from "./DataBankAnalyticsPanel";
import { isDataBankSourceReady } from "./dataBankSourceHelpers";

function AnalyticsContentInner() {
  const { tarsAnalyticsStore, tarsStore } = useStore();
  const { facetCount, selectedFacetId } = tarsAnalyticsStore;
  const selectedId = tarsAnalyticsStore.selectedSourceIds[0];
  const selectedNode = selectedId ? tarsStore.getNode(selectedId) : undefined;
  const dataBankFile =
    selectedNode &&
    !isFolder(selectedNode) &&
    (selectedNode as SourceFile).type === "dataBank" &&
    isDataBankSourceReady(selectedNode as SourceFile)
      ? (selectedNode as SourceFile)
      : null;

  if (
    selectedNode &&
    !isFolder(selectedNode) &&
    (selectedNode as SourceFile).type === "dataBank" &&
    !dataBankFile
  ) {
    return (
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center bg-[#f9fafb] p-6">
        <p className="max-w-md text-center text-sm text-gray-600">
          This data bank source is missing AC or content details. Open edit on the source or add it
          again with all fields selected.
        </p>
      </div>
    );
  }

  if (dataBankFile) {
    return (
      <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-auto bg-[#f9fafb] p-4">
        <DataBankAnalyticsPanel file={dataBankFile} />
      </div>
    );
  }

  if (facetCount === 0) {
    return (
      <div className="flex min-h-0 flex-1 items-center justify-center bg-[#f9fafb] p-6">
        <p className="text-sm text-gray-500">
          Add or generate facets to see analytics here.
        </p>
      </div>
    );
  }

  if (!selectedFacetId) {
    return (
      <div className="flex min-h-0 flex-1 items-center justify-center bg-[#f9fafb] p-6">
        <p className="text-sm text-gray-500">Select a facet in the canvas list.</p>
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col bg-[#f9fafb]">
      <FacetJsonWorkspacePanel facetId={selectedFacetId} />
    </div>
  );
}

export default observer(AnalyticsContentInner);
